
export const management = {
  namespaced: true,
  state: {
    clientePagador: "",
    changeAddress: "",
    changePostalCode: "",
    changeLocation: "",
    changeProvince: "",
    changePhone: "",
    changeFax: "",
    changeNombreUsuario: "",
    changeNif: "",

  },
  getters: {
    IS_AUTHENTICATED(state) {
      return state.token == null ? false : true;
    },
  },
  mutations: {
    changeNif(state, payload) {
      state.changeNif = payload
      
    },


    clientePagador(state, payload) {
      state.clientePagador = payload
    },

    changeNombreUsuario(state, payload) {
      state.changeNombreUsuario = payload
    },

    changeAddress(state, payload) {
      state.changeAddress = payload
    },
    changePostalCode(state, payload) {
      state.changePostalCode = payload
    },

    changeLocation(state, payload) {
      state.changeLocation = payload
    },

    changeProvince(state, payload) {
      state.changeProvince = payload
    },
    changePhone(state, payload) {
      state.changePhone = payload
    },

    changeFax(state, payload) {
      state.changeFax = payload
    },

    changeEmail(state, payload) {
      state.changeEmail = payload

    },

  },
  actions: {
  },
}